import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment.model';

import { CropAid } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropAidService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/';

  getCropAids(): Observable<CropAid[]> {
    return this.http.get<{ cropAids: CropAid[] }>(`${this.baseUrl}crop-aid`).pipe(map(({ cropAids }) => cropAids));
  }
}
